module.exports = {
  fastDelivery: '尽快送达',
  appointmentDelivery: '预约送达',
  fastOrder: '极速30min',
  // 待接单提示
  waitOrder: '请在 {args1} 前接单',
  // 开始备餐
  preOrder: '请在 {args1} 前开始备餐',
  // 完成备餐
  preMealOrder: '请在 {args1} 前完成备餐',
  // 备餐完成
  completeMealOrder: '已在 {args1} 备餐完成',
  // 处理取消申请
  processCancelOrder: '请在 {args1} 前处理取消申请',
  // 完成订单
  completeOrder: '已在 {args1} 完成订单',
  // 取消订单
  cancelOrder: '已在 {args1} 取消订单',
  // 订单号
  orderNo: '订单号',
  // 下单时间
  orderTime: '下单时间',
  orderDate: '下单日期',
  showAll: '查看全部',
  // 共{args}种商品
  allProduct: '共{args1}件商品',
  orderTimes: '第 {args1} 次下单',
  // 配送费
  deliveryFee: '配送费',
  // 增值税
  vat: '增值税',
  platformDiscount: '平台折扣',
  platformFull: '平台满减',
  platformCoupons: '平台优惠券',
  storeFull: '门店满减',
  storeFirstOrder: '门店首单',
  storeShipping: '运费券',
  storeCoupons: '门店优惠券',
  custPay: '客户支付',
  estimatedIncome: '预计收入',
  consigneeName: '收货人姓名',
  recipientAddress: '收货人地址',
  orderStatus: '订单状态',
  deliveryStatus: '配送状态',
  remark: '备注',
  noRemark: '无备注',
  productDetails: '商品详情',
  picture: '图片',
  name: '名称',
  specification: '规格 ',
  attributes: '属性',
  quantity: '数量',
  total: '总计',
  price: '价格',
  totalAmount: '总金额',
  totalNum: '总数量',
  writeReason: '请输入{args1}理由',
  linkTel: '联系电话',
  receiverPhone: '客户电话',
  riderPhone: '骑手电话',
  stationPhone: '配送站电话',
  automaticOrder: '自动接单',
  mark: '标识码',
  acceptOrder: '接单',
  rejectOrder: '拒单',
  rejectReason: '请输入拒单理由？',
  reasonNull: '理由不能为空',
  startTime: '开始日期时间',
  asOfTime: '结束日期时间',
  prepareMeal: '开始备餐',
  prepareFinish: '备餐完成',
  agreeRefund: '同意退款',
  refuseRefund: '拒绝退款',
  agreeCancel: '同意取消',
  rejectCancel: '拒绝取消',
  refundDesc: '退款描述',
  OriginalPrice: '总原价',
  discountPrice: '优惠后总价',
  applying: '取消申请中',
  refunding: '退款申请中',
  canceled: '已取消',
  appointmentPass: '预约单到期',
  promotionCode: '促销码',
  showDetail: '商品详情',
  productGift: '赠品',
  cancelReason: '取消原因',
  selectReason: '请选择拒单原因？',
  storeRating: '门店评分',
  goodEvaluateRate: '好评率',
  evaluate: '评价',
  replyOrNot: '是否回复',
  replied: '已回复',
  unReplied: '未回复',
  custPhoto: '客户头像',
  custNick: '客户昵称',
  evaluateTime: '评价时间',
  evaluateScore: '评分',
  evaluateContent: '评价内容',
  storeReply: '门店回复',
  replyTime: '回复时间',
  reply: '回复',
  custEvaluate: '客户评价',
  hasContent: '有无内容',
  haveContent: '有评论内容',
  noContent: '无评论内容',
  photo: '图片',
  requiredReply: '备注（必填，500字符）',
  allPicture: '共{num}张图片',
  largeOrderTips: '该订单涉及数额较大，请谨慎处理',
  feedbackTitle:'反馈异常',
  contactInfo: '联系方式',
  feedbackReason: '反馈原因',
  detailDesc: '详细说明',
  descPlaceholder: '问题描述/期望处理方式等',
  pic: '反馈图片',
  merchant :'商家',
  feedbackDetailTitle: '反馈异常详情',
  feedbackNo: '反馈编号',
  feedbackRole: '反馈人',
  feedbackTime: '反馈时间',
  handleLog: '处理历史',
  pending: '待处理',
  processing: '处理中',
  Solved: '已解决',
  Rejected: '已驳回',
  time: '时间',
  type: '类型',
  operatorName : '操作人',
  logCnt: '处理内容',
  logStatus : '处理状态',
  checkFeedback: '查看异常反馈',
  issueOrder: '订单有疑问?',
  try: '试试',
  orderFeedback: '反馈异常',
  submitFeedback:'提交反馈',
  acceptFeedback:'接取',
  handleFeedback:"处理",
  completeFeedback:"处理完成",
  solvedFeedback:"处理完成-已解决",
  vatRate: '增值税率',
  originalTotalPrice: '商品总原价',
  totalPriceAfterDiscount: '商品优惠后总价',
  pendingSettleTip: '未结算（预计{time}前结算）',
  doneSettleTip: '已结算（{time}）',
  userPicked: '用户已取餐',
  selfPickUp: '到店自取',
  userPickedOrderTipTitle: '温馨提示',
  userPickedOrderTip: '温馨提示 如用户已收到商品，请点确定完成订单。',
}
